import type { ReactElement, SVGProps } from "react";

export function RewardsIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.1475 4.88477L20.6738 5.66895L20.3125 9.2959L22.7051 12L20.3125 14.7041L20.6738 18.3311L17.1475 19.1152L15.3281 22.2305L12.001 20.8232L8.67383 22.2305L6.85449 19.1152L3.32812 18.3311L3.68945 14.7041L1.29688 12L3.68945 9.2959L3.32812 5.66895L6.85449 4.88477L8.67383 1.76953L12.001 3.17676L15.3281 1.76953L17.1475 4.88477ZM14.6084 13C14.1621 13 13.7824 13.1564 13.4697 13.4688C13.1572 13.7812 13.001 14.1604 13.001 14.6064C13.001 15.0528 13.1574 15.4325 13.4697 15.7451C13.7822 16.0576 14.1614 16.2139 14.6074 16.2139C15.0538 16.2139 15.4334 16.0575 15.7461 15.7451C16.0586 15.4327 16.2148 15.0535 16.2148 14.6074C16.2148 14.1611 16.0584 13.7814 15.7461 13.4688C15.4337 13.1563 15.0544 13 14.6084 13ZM8.00684 14.6572L9.55762 16.208L16.209 9.55664L14.6582 8.00586L8.00684 14.6572ZM9.6084 8C9.1621 8.00002 8.78237 8.15644 8.46973 8.46875C8.15724 8.78119 8.00099 9.16042 8.00098 9.60645C8.00098 10.0528 8.15739 10.4325 8.46973 10.7451C8.78218 11.0576 9.16137 11.2139 9.60742 11.2139C10.0538 11.2139 10.4334 11.0575 10.7461 10.7451C11.0586 10.4327 11.2148 10.0535 11.2148 9.60742C11.2148 9.16112 11.0584 8.7814 10.7461 8.46875C10.4337 8.15629 10.0544 8 9.6084 8Z"
        fill="#9600F1"
      />
    </svg>
  );
}
